module.exports = __webpack_public_path__ + "img/arrow-left-circle-fill.76949596.svg";